import type { AnchorHTMLAttributes } from 'react';
import { Link } from 'react-router-dom';
import type { GameDefinition } from '../registry';
type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
    game: GameDefinition;
};
export function GameEntryLink({ game, children, ...props }: Props) {
    if (game.kind === 'external') {
        return <a {...props} data-game-entry={game.slug} href={game.href} target="_blank" rel="noopener noreferrer" title="外部网站，在新标签页打开">{children}</a>;
    }
    return <Link {...props} data-game-entry={game.slug} to={game.path}>{children}</Link>;
}
